import { MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { waLink, scrollToId } from "@/config";

const Footer = () => (
  <footer className="bg-blue-deep text-ivory" data-testid="site-footer">
    <div className="container-edit py-16 lg:py-24">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-7">
          <Logo light />
          <p className="mt-8 max-w-md font-serif text-2xl font-light leading-snug text-ivory/90 sm:text-3xl">
            The best price is a conversation. <em className="italic text-cyan">Start yours today.</em>
          </p>
          <button
            data-testid="footer-whatsapp-button"
            onClick={() => window.open(waLink("Hi! I want a better price on my trip."), "_blank")}
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-ivory px-7 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:bg-cyan hover:text-ink active:scale-[0.98]"
          >
            <MessageCircle className="h-4 w-4" />
            Chat on WhatsApp
          </button>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/50">Explore</p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80">
            <li><button data-testid="footer-link-categories" className="transition-colors hover:text-cyan" onClick={() => scrollToId("categories")}>Categories</button></li>
            <li><button data-testid="footer-link-how" className="transition-colors hover:text-cyan" onClick={() => scrollToId("how")}>How it works</button></li>
            <li><button data-testid="footer-link-price" className="transition-colors hover:text-cyan" onClick={() => scrollToId("get-started")}>Get a price</button></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/50">We price</p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80">
            <li>Flights</li>
            <li>Hotels</li>
            <li>Holiday packages</li>
            <li>Buses</li>
            <li>Trains — zero fees above ₹2,000</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-ivory/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/50">
          © {new Date().getFullYear()} Naditra · naditra.in
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/50">
          If we can't beat your quote, we'll say so
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
